<template>
  <base-avatar
    v-bind="$attrs"
    :background-color="bkgdColor"
  />
</template>

<script>
export default {
  name: 'Avatar',
  inheritAttrs: false,
  data() {
    return {
      bkgdColor: '#E9AD7D',
    };
  },
  mounted() {
    const parentClass = this.$el.parentElement.className;
    // eslint-disable-next-line
    !parentClass.includes('client') ? (this.bkgdColor = '#E6A0A0') : null;
  },
};
</script>
